module.exports = __webpack_public_path__ + "static/22-code-sheriff-d01a3a7b185751b6f029a530efaa5a26.png";